/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React, {
    useState, useCallback, useRef, useEffect,
} from 'react';
import moment from 'moment';
import { Calendar } from 'react-calendar';
// import { createUrl } from '../../../redux/helper/CreateQuery';

function FilterModal({
    filterModal, setFilterModal, selected,
    setselected, filterValue, setfilterValue, handleFilter, SetSuccessMessage,
}) {
    const dateRef = useRef();
    const [selectedType, setselectedType] = useState('date_range');
    const toggleState = {
        start_date: false,
        end_date: false,
    };

    const [toggle, settoggle] = useState(toggleState);

    const handleToggle = (key) => {
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
        }));
    };

    const handleDate = (val, key) => {
        const state = key === 'start_date' ? 'end_date' : 'start_date';
        if (key === 'start_date') {
            setselected((prevState) => ({
                ...prevState,
                end_date: '',
            }));
        }
        settoggle(toggleState);
        if (key === 'end_date') {
            settoggle(toggleState);
        } else {
            setTimeout(() => {
                handleToggle(state);
            }, 500);
        }
        setselected((prevState) => ({
            ...prevState,
            [key]: val,
        }));
        if (key === 'end_date') {
            settoggle(toggleState);
        }
    };

    const handleClear = () => {
        setselected({ start_date: '', end_date: '' });
        setfilterValue('');
        // handlePendingOrderReports();
        setFilterModal(false);
        SetSuccessMessage('Filter(s) cleared');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 2000);
    };

    // const HandleFilter = useCallback((key, val) => {
    //     const Filtercopy = { ...Filter };
    //     const idx = Filtercopy[key].indexOf(val);
    //     if (idx === -1) {
    //         Filtercopy[key].push(val);
    //     } else {
    //         Filtercopy[key].splice(idx, 1);
    //     }
    //     Filtercopy[key];
    //     setFilter(Filtercopy);
    //     return idx > -1;
    //     // return false
    // }, []);

    const generateFilterQuery = (val) => {
        let final = '';
        if (selected.start_date !== '' && selected.end_date !== '') {
            final += `&date_range=${moment(selected.start_date).format('DD-MM-YYYY')},${moment(selected.end_date).format('DD-MM-YYYY')}`;
        }
        if (val === undefined) {
            handleFilter(final);
        }
        setFilterModal(false);
        SetSuccessMessage('Filter(s) applied');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 2000);
        return final;
    };

    useEffect(() => {
        const handler = (event) => {
            if (dateRef && !dateRef.current.contains(event.target)) {
                settoggle((prevState) => ({
                    ...prevState,
                    start_date: false,
                    end_date: false,
                }));
                // setNotificationDropdown(false)
                // setReportsDropdown(false)
            }
        };
        document.addEventListener('mousedown', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, [dateRef]);

    return (
        <div className={`modal fade fixed top-0 left-0 ${filterModal ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="filtermodal" tabIndex="-1" aria-labelledby="deactivateOfferModal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:max-w-[520px] mx-auto px-2.5" style={{ margin: 'auto' }}>
                <div
                    className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
                >
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[14px] rounded-t-md">
                        <h5 className="sm:text-xs4 text-lg font-semibold text-[#555259] text-center w-full" id="exampleModalScrollableLabel1">
                            Filter
                        </h5>
                        <button
                            type="button"
                            className="absolute top-4 right-6"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setFilterModal(false)}
                        >
                            <img src="images/close.svg" alt="icon" className="w-3.5 h-3.5" />
                        </button>
                    </div>
                    <div className="modal-body relative sm:pl-5 pr-7 px-3 sm:pt-5 pt-4 pb-[18px] text-center">
                        <div className="flex items-start">
                            <ul className="nav nav-pills flex flex-col flex-wrap items-start list-none pl-0 w-[30%] h-full" id="pills-tabVertical" role="tablist">
                                <li className="nav-item flex-grow w-full text-start mb-4" role="presentation">
                                    <a
                                        href="#pills-pricetab"
                                        className={`nav-link block ${selectedType === 'date_range' ? 'active' : ''} text-base font-semibold text-[#AAA6AF] order relative w-full`}
                                        id="pills-ordercategory"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-pricetab"
                                        role="tab"
                                        aria-controls="pills-pricetab"
                                        aria-selected="true"
                                    >
                                        Date Range
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content w-[70%] h-[198px] border-l border-[#D8D8D8]" id="pills-tabContentVertical">
                                <div ref={dateRef} className={`tab-pane fade ${selectedType === 'date_range' ? 'show active' : ''} px-3 h-[198px]`} id="pills-pricetab" role="tabpanel" aria-labelledby="pills-ordercategory">
                                    <div className="relative">
                                        <div className="flex sm:flex-row flex-col items-center mt-1 -mx-1">
                                            <div
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('start_date')}
                                            >
                                                <label />
                                                <img
                                                    src="images/Iconawesome-calendar-alt.svg"
                                                    alt="icon"
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('start_date')}

                                                />
                                                <input
                                                    datepicker
                                                    datepicker-autohide
                                                    type="text"
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] sm:text-xs9 text-sm29 font-semibold text-[#090406] px-2.5 placeholder:text-xs9 placeholder:font-normal placeholder:text-[#808285]"
                                                    placeholder="From date"
                                                    value={selected.start_date === '' ? '' : moment(selected.start_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            <div
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('end_date')}

                                            >
                                                <label />
                                                <img
                                                    src="images/Iconawesome-calendar-alt.svg"
                                                    alt="icon"
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('end_date')}

                                                />
                                                <input
                                                    datepicker
                                                    datepicker-autohide
                                                    type="text"
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] sm:text-xs9 text-sm29 font-semibold text-[#090406] px-2.5 placeholder:text-xs9 placeholder:font-normal placeholder:text-[#808285]"
                                                    placeholder="To date"
                                                    value={selected.end_date === '' ? '' : moment(selected.end_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                        </div>
                                        {toggle.start_date && (
                                            <Calendar
                                                value={moment(selected.start_date).format('YYYY/MM/DD').start_date}
                                                onChange={(val) => handleDate(val, 'start_date')}
                                                placeholder="Date from"
                                            />
                                        )}
                                        {toggle.end_date && (
                                            <Calendar
                                                value={selected.end_date}
                                                onChange={(val) => handleDate(val, 'end_date')}
                                                minDate={moment(selected.start_date).toDate()}
                                                placeholder="Date to"
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex w-full">
                            <div className="pt-3 flex justify-end w-[30%] mr-4">
                                <button
                                    type="button"
                                    className="w-full sm:h-10 h-9 border-2 border-[#555259]  bg-[#FFFFFF] rounded-lg text-sm font-semibold filter2 text-[#555259]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => handleClear()}
                                >
                                    Clear Filter
                                </button>
                            </div>
                            <div className="pt-3 flex justify-end w-[70%]">
                                <button
                                    type="button"
                                    className="w-full sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold filter3 text-[#FFFFFF]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => generateFilterQuery()}
                                >
                                    Apply Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FilterModal;
